export const isAccessDeniedError = error =>
  error && error.errorCode && error.errorCode === 'access_denied';
